export const vehicleConfig: DataViewConfig = {
    items: [
        {
            title: 'Plate Number',
            field: 'regPlate',
            dataType: 'text'
        },
        {
            title: 'Status',
            field: 'status',
            dataType: 'text'
        },
        {
            title: 'Total Trips',
            field: 'totalTrips',
            dataType: 'number'
        },
        {
            title: 'Total Earned',
            field: 'totalEarned',
            dataType: 'amount'
        }
    ]
}